import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  detailsContainer: {
    backgroundColor: '#f6f6f6',
    padding: theme.spacing(1.5),
  },

  detailsRow: {
    fontSize: '14px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 0.3,
    color: theme.palette.text.primary,
  },

  detailsTitle: {
    fontFamily: 'Source Sans Pro Bold',
  },

  divider: {
    margin: `${theme.spacing(1.2)} 0`,
  },

  employeeSelect: {
    margin: `0 0 ${theme.spacing(0)} 0`,
  },

  formLabel: {
    margin: `${theme.spacing(1.2)} 0`,
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
    letterSpacing: '0.3px',
    color: theme.palette.text.primary,
  },

  infoIcon: {
    color: theme.palette.action.active,
    fontSize: '24px',
    verticalAlign: 'middle',
    pointerEvents: 'all',
  },

  menuItemIcon: {
    opacity: '1',
    color: 'rgba(51, 56, 59, 0.5)',
    cursor: 'default',
    pointerEvents: 'none',
  },

  infoWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },

  noLabel: {
    fontSize: '14px',
    color: '#ddd',
  },

  small: {
    fontSize: '14px',
    color: '#666',
  },

  timeZoneLabel: {
    fontSize: 14,
    color: theme.palette.text.primary,
  },

  timeZoneTitle: {
    fontWeight: 'bold',
    marginRight: theme.spacing(0.6),
  },

  ErrorLabel: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(1.4),
    marginTop: theme.spacing(0),
    fontSize: '0.75rem',
  },
  infoActiveIcon: {
    fontSize: '22px',
    verticalAlign: 'middle',
    pointerEvents: 'all',
    mb: 0.2,
    opacity: 1,
  },
})

export const getSwitchStyles = (theme: Theme) => ({
  detailsContainer: {
    backgroundColor: '#f6f6f6',
    padding: theme.spacing(1.5),
  },

  detailsRow: {
    fontSize: '14px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 0.3,
    color: theme.palette.text.primary,
  },

  detailsTitle: {
    fontFamily: 'Source Sans Pro Bold',
  },

  divider: {
    margin: `${theme.spacing(1.2)} 0`,
  },

  employeeSelect: {
    margin: `0 0 ${theme.spacing(0)} 0`,
  },

  formLabel: {
    margin: `${theme.spacing(1.2)} 0`,
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
    letterSpacing: '0.3px',
    color: theme.palette.text.primary,
  },

  infoIcon: {
    color: theme.palette.primary.light,
    cursor: 'help',
    fontSize: '18px',
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
    pointerEvents: 'all',
    opacity: '1',
  },

  menuItemIcon: {
    opacity: '1',
    color: 'rgba(51, 56, 59, 0.5)',
    cursor: 'default',
    pointerEvents: 'none',
  },

  infoWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },

  noLabel: {
    fontSize: '14px',
    color: '#ddd',
  },

  small: {
    fontSize: '14px',
    color: '#666',
  },

  timeZoneLabel: {
    fontSize: 14,
    color: theme.palette.text.primary,
    marginTop: theme.spacing(1.5),
  },

  timeZoneTitle: {
    fontWeight: 'bold',
    marginRight: theme.spacing(0.6),
  },

  ErrorLabel: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(1.4),
    marginTop: theme.spacing(0),
    fontSize: '0.75rem',
  },
})

export const getFormControlStyles = (theme: Theme) => ({
  detailsContainer: {
    backgroundColor: '#f6f6f6',
    padding: theme.spacing(1.5),
  },

  detailsRow: {
    fontSize: '14px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 0.3,
    color: theme.palette.text.primary,
  },

  detailsTitle: {
    fontFamily: 'Source Sans Pro Bold',
  },

  divider: {
    margin: `${theme.spacing(1.2)} 0`,
  },

  employeeSelect: {
    margin: `0 0 ${theme.spacing(0)} 0`,
  },

  formLabel: {
    margin: `${theme.spacing(1.2)} 0`,
    fontSize: '16px',
    fontFamily: 'Source Sans Pro Semibold',
    letterSpacing: '0.3px',
    color: theme.palette.text.primary,
  },

  infoIcon: {
    color: theme.palette.primary.light,
    cursor: 'help',
    fontSize: '18px',
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
    pointerEvents: 'all',
    opacity: '1',
  },

  menuItemIcon: {
    opacity: '1',
    color: 'rgba(51, 56, 59, 0.5)',
    cursor: 'default',
    pointerEvents: 'none',
  },

  infoWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },

  noLabel: {
    fontSize: '14px',
    color: '#ddd',
  },

  small: {
    fontSize: '14px',
    color: '#666',
  },

  timeZoneLabel: {
    fontSize: 14,
    color: theme.palette.text.primary,
    marginTop: theme.spacing(1.5),
  },

  timeZoneTitle: {
    fontWeight: 'bold',
    marginRight: theme.spacing(0.6),
  },

  ErrorLabel: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(1.4),
    marginTop: theme.spacing(0),
    fontSize: '0.75rem',
  },
})
